import { RouteConfig } from '../types';
import { ONBOARDING_KEYS } from '../constants';
import { HELP_CENTER_LINKS } from '../helpCenterLinks';

export const monitoringAlertsSteps = [
  {
    element: '[data-onboarding="alert-tabs"]',
    popover: {
      title: 'Alert Tabs',
      description:
        'These three tabs group alerts by stage. Use them to navigate between different alert states.',
      side: 'bottom' as const,
      align: 'start' as const,
    },
  },
  {
    element: '[data-onboarding="alert-tab-new"]',
    popover: {
      title: 'New Alerts',
      description:
        `The Alerts tab shows unassigned alerts to be viewed by Quill or a <a href="${HELP_CENTER_LINKS.monitoringAgent}" target="_blank" class="text-lime underline">monitoring agent</a>.`,
      side: 'bottom' as const,
      align: 'start' as const,
    },
  },
  {
    element: '[data-onboarding="alert-tab-assigned"]',
    popover: {
      title: 'Assigned Alerts',
      description:
        'The Assigned tab shows alerts that have been picked up by a monitoring agent and are currently being handled.',
      side: 'bottom' as const,
      align: 'start' as const,
    },
  },
  {
    element: '[data-onboarding="alert-tab-resolved"]',
    popover: {
      title: 'Resolved Alerts',
      description:
        'The "Resolved" tab stores recently resolved alerts for reference.',
      side: 'bottom' as const,
      align: 'start' as const,
    },
  },
  {
    element: '[data-onboarding="new-alerts"] [data-alert-index="0"]',
    popover: {
      title: 'Latest Alert',
      description:
        'Each card shows a summary of an alert. Select the top card to open the newest alert, check the evidence, and decide what action to take.',
      side: 'top' as const,
      align: 'start' as const,
    },
  },
];

export const monitoringRoutes: RouteConfig[] = [
  {
    id: 'monitor',
    processName: ONBOARDING_KEYS.monitoringAlerts,
    match: (path: string) => path === '/monitor',
    steps: monitoringAlertsSteps,
  },
];
